const cooldownMap = new Map()

// 对高频事件做冷却控制：
// 同一个 key 在 cooldownMs 时间内只允许通过一次。
export const hitMonitorCooldown = (key, cooldownMs = 0) => {
  if (!key || cooldownMs <= 0) {
    return false
  }

  const now = Date.now()

  for (const [entryKey, expiresAt] of cooldownMap.entries()) {
    if (expiresAt <= now) {
      cooldownMap.delete(entryKey)
    }
  }

  const expiresAt = cooldownMap.get(key)
  if (expiresAt && expiresAt > now) {
    return true
  }

  cooldownMap.set(key, now + cooldownMs)
  return false
}
